<template>
  <div>
    <!-- 头部 -->
    <Head></Head>
    <!-- 尾部 -->
    <div class="cart w">
      <div class="top">
        <a href="javascript:;">RAKUMART商品({{ cartCount }})</a>
      </div>
      <router-view></router-view>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/Head";
import Foot from "../../components/foot/Foot";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isChoose: 1,
    };
  },
  components: {
    Head,
    Foot,
  },
  computed: {
    ...mapState(["cartCount"]),
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.cart {
  margin-top: 40px;
  .top {
    color: #ccc;
    border-bottom: 1px solid #ccc;
    a {
      display: inline-block;
      padding: 0 15px 10px;
      font-size: 18px;
      color: #f3c622;
    }
  }
}
</style>